export default {
  init(selector) {
    $(selector).on('click', this.clickHandler(selector))
  },

  clickHandler(selector) {
    return (e) => {
      const targetArea = $(e.target).closest(`${selector}__target-area`)

      if (targetArea.find(`${selector}__target`).hasClass('close')) {
        targetArea.find(`${selector}__target`).removeClass('close')
        targetArea.find('.toggle_link__text').text('閉じる')
        targetArea.find('.toggle_link__icon').css('transform', 'rotate(270deg)')
      } else {
        targetArea.find(`${selector}__target`).addClass('close')
        targetArea.find('.toggle_link__text').text('表示する')
        targetArea.find('.toggle_link__icon').css('transform', 'rotate(90deg)')
      }
      targetArea.find(`${selector}__target`).slideToggle()

      return false
    }
  },
}
